import http from "../http";

const apiUrl = `${process.env.REACT_APP_API_URL}air-bookings`;

// POST /air-bookings
export function createAirBooking(data) {
  return http.post(apiUrl, data);
}

// GET /air-bookings
export function getAirBookings(id, limit, pageNumber, tabValue) {
  const params = {
    page: pageNumber,
    limit: limit,
    tabValue: tabValue,
    id: id,
  };
  return http.get(apiUrl, { params });
}

// POST /air-bookings/find-one-any
export function findOneAirBookingByAny(queryParams) {
  return http.post(`${apiUrl}/find-one-any`, queryParams);
}

// POST /air-bookings/find-all-any
export function findAllAirBookingsByAny(queryParams) {
  return http.post(`${apiUrl}/find-all-any`, queryParams);
}

// GET /air-bookings/findByUserId
export function findAirBookingByUserId(userId) {
  return http.get(`${apiUrl}/findByUserId`, { params: { userId } });
}

// GET /air-bookings/findByVendorId
export function findAirBookingByVendorId(vendorId) {
  return http.get(`${apiUrl}/findByVendorId`, { params: { vendorId } });
}

// GET /air-bookings/findByB2bUserId
export function getCountBookingStatus(params) {
  return http.get(`${apiUrl}/status-count`, { params });
}

export function getAirlineBookingCount(params) {
  return http.get(`${apiUrl}/airline-count`, { params });
}

export function getChannelBookingCount(params) {
  return http.get(`${apiUrl}/channel-count`, { params });
}

export function getGdsBookingCount(params) {
  return http.get(`${apiUrl}/gds-count`, { params });
}

export function getAirlineStats(params) {
  return http.get(`${apiUrl}/airline-stats`, { params });
}

export function getVendorAirlineStats(params) {
  return http.get(`${apiUrl}/vendor-airline-stats`, { params });
}

export function findAirBookingByB2bUserId(b2bUserId) {
  return http.get(`${apiUrl}/findByB2bUserId`, { params: { b2bUserId } });
}

// GET /air-bookings/{id}
export function getAirBookingById(id) {
  return http.get(`${apiUrl}/${id}`);
}

// PATCH /air-bookings/{id}
export function updateAirBooking(data) {
  return http.patch(`${apiUrl}/${data.id}`, data);
}

export function refundAirBooking(data) {
  return http.post(`${apiUrl}/refund-booking`, data);
}

export function splitAirBooking(data) {
  return http.patch(`${apiUrl}/split-booking/${data.id}`, data);
}

// PATCH /air-bookings/vendor-ticket-settlement/{id}
export function updateVendorTicketSettlement(data) {
  return http.patch(`${apiUrl}/vendor-ticket-settlement/${data.id}`, data);
}

// PATCH /air-bookings/{id}
export function updateIssueTicketManual(data) {
  return http.patch(`${apiUrl}/issue-ticket-manual/${data.id}`, data);
}

//GET /air-bookings/getWithMetadata/{id}
export function getAirBookingWithMetadata(id) {
  return http.get(`${apiUrl}/getWithMetadata/${id}`);
}

// GET /air-bookings/status-count
export function getAirBookingStatusCount(params) {
  return http.get(`${apiUrl}/status-count`, { params });
}

export function getSegmentCountByAirline(params) {
  return http.get(`${apiUrl}/segment-count/by-airline`, { params });
}

export function getSegmentCountBySector(params) {
  return http.get(`${apiUrl}/segment-count/by-sector`, { params });
}

export function getSegmentCountByGds(params) {
  return http.get(`${apiUrl}/segment-count/by-gds`, { params });
}

export function getSegmentCountByAgent(params) {
  return http.get(`${apiUrl}/segment-count/by-agent`, { params });
}

export function getSegmentCountByBookingVendor(params) {
  return http.get(`${apiUrl}/segment-count/by-booking-vendor`, { params });
}

export function getSegmentCountByCustomer(params) {
  return http.get(`${apiUrl}/segment-count/by-customer`, { params });
}

// GET /air-bookings/by-search
export function searchAirBookings(params) {
  return http.get(`${apiUrl}/by-search`, { params });
}
